import { getConfig } from '@superbet-group/web.lib.config';
import {
    isPoland,
    isSerbia,
} from './isCountry';
import preparePhoneNumber from './preparePhoneNumber';

export default function shouldOpenWApp(isMobile: boolean) {
    const config = getConfig();

    if (isPoland() || isSerbia()) {
        const wAppNumber = preparePhoneNumber(config.countrySpecific.footer.whatsAppNumber);

        if (isMobile) {
            window.location.href = `whatsapp://send?phone=${wAppNumber}`;
        } else {
            window.open(`https://wa.me/${wAppNumber}`, '_blank')?.focus();
        }
    }
}
